import React from 'react'
import ServiceFormToolbar from './ServiceFormToolbar'
import ServiceFormContainer from './ServiceFormContainer'
import { Button } from 'react-bootstrap'

const ServiceFormPagerView = ({
  pageNumber,
  totalPage,
  totalCount,
  onPageChange,
  dateValue,
  onDateChange,
  searchArchived,
  onSearchArchivedChange,
  goPrevPage,
  goNextPage,
  hasPrevPage,
  hasNextPage,
  currentServiceTxn,
  onFormSubmit,
  onViewServiceTxnBySeq,
  onExportButtonClick,
  isNeedWorkSheet,
  auth,
}) => (
  <div className="panel panel-default">
    <div className="panel-heading">
      <div className="row">
        <div className="col-md-1 text-left">
          <Button
            className=" btn btn-primary pager-btn"
            onClick={goPrevPage}
            disabled={hasPrevPage ? false : true}
          >
            <span className="glyphicon glyphicon-chevron-left"></span>
          </Button>
        </div>
        <div className="col-md-10">
          <ServiceFormToolbar
            dateValue={dateValue}
            onViewServiceTxnBySeq={onViewServiceTxnBySeq}
            onExportButtonClick={onExportButtonClick}
            isNeedWorkSheet={isNeedWorkSheet}
            onDateChange={onDateChange}
            searchArchived={searchArchived}
            onSearchArchivedChange={onSearchArchivedChange}
            pageNumber={pageNumber}
            totalPage={totalPage}
            totalCount={totalCount}
            onPageChange={onPageChange}
            auth={auth}
          />
        </div>
        <div className="col-md-1 text-right pager-btn">
          <Button
            className=" btn btn-primary"
            disabled={hasNextPage ? false : true}
            onClick={goNextPage}
          >
            <span className="glyphicon glyphicon-chevron-right"></span>
          </Button>
        </div>
      </div>
    </div>
    <ServiceFormContainer
      onSubmit={onFormSubmit}
      serviceTxn={currentServiceTxn}
      searchArchived={searchArchived}
    />
  </div>
)

export default ServiceFormPagerView
